import { Box, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { Link } from "react-scroll";
import { commonTypographyStyles } from "../utils";
import type { HeaderMenuDropdownProps } from "./types/HeaderMenuDropdownProps";

export function HeaderMenuDropdown({ navItem }: HeaderMenuDropdownProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Typography onClick={handleOpen} sx={commonTypographyStyles}>
        {navItem.title}
      </Typography>
      {anchorEl && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          disableScrollLock
          autoFocus={false}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          {navItem.subMenu?.map((sub) => (
            <MenuItem key={sub.id}>
              <Link
                to={sub.id}
                smooth
                onClick={() => {
                  handleClose();
                  window.history.pushState(null, "", `#${sub.id}`);
                }}
                offset={-100}
                duration={500}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  width: "100%",
                  display: "block",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                <Typography sx={{ px: 1.5, py: 1.5 }}>{sub.title}</Typography>
              </Link>
            </MenuItem>
          ))}
        </Menu>
      )}
    </Box>
  );
}
